import request from "@/utils/request";

// 用户信息
export async function getAccountInfo(params: any) {
  return request.get("/my/v19/info", {
    params: params,
  });
}

// 红包明细
export async function getRedpacketDetail(params: any) {
  return request.get("/my/redpacket", {
    params: params,
  });
}

// 红包兑换
export async function exchangeRedpacket(params: any) {
  return request.get("/my/redpacket_exchange", {
    params: params,
  });
}

// 订单明细
export async function getOrderDetail(params: any) {
  return request.get("/my/order", {
    params: params,
  });
}

// 红包、礼包、分享等奖励领取
// todo 接口名称有误
export async function receiveAward(params: any) {
  return request.get("/reward/v19/go", {
    params: params,
  });
}

// 获取侧边菜单
export async function getMenus() {
  return request.get("/my/v14/menuVx");
}

// 获取红包、礼包、分享等待领取情况
// 用于显示tabbar角标
export async function getTaskBadges() {
  return request.get("/my/task");
}

// 设置用户别名
export async function setUserAlias(params: any) {
  return request.get("/User/setAlias", {
    params: params,
  });
}

// 实名认证
export async function realnameAuth(params: any) {
  return request.get("/Name/v4/auth", {
    params: params,
  });
}

// 获取验证码
export async function getCaptcha(params: any) {
  return request.get("/User/v19/captcha", {
    params: params,
  });
}

// 绑定手机
export async function bindPhone(params: any) {
  return request.get("/User/v19/bindPhone", {
    params: params,
  });
}

// 解绑手机
export async function unbindPhone(params: any) {
  return request.get("/User/v19/unbindPhone", {
    params: params,
  });
}

// 重新绑定手机 - 验证旧号码
export async function validateOldPhone(params: any) {
  return request.get("/User/rebindPhone", {
    params: params,
  });
}

// 修改密码
export async function changePassword(params: any) {
  return request.get("/User/editPwd", {
    params: params,
  });
}

// 设置密码
export async function setPassword(params: any) {
  return request.get("/User/setPwd", {
    params: params,
  });
}

// 获取用户个人信息 （客服页）
export async function getCurrentUser(params: any) {
  return request.get("/QiyuV1/roleInfo", {
    params: params,
  });
}

// 获取大红包信息
export async function getBigRedInfo(params: any) {
  return request.get("/MyBigRedpacket/info", {
    params: params,
  });
}

// 兑换大红包
export async function exchangeBigRed(params: any) {
  return request.get("/MyBigRedpacket/redpacket_exchange", {
    params: params,
  });
}

// 用户权益
export async function getUserRight(params: any) {
  return request.get("/userright/config", {
    params: params,
  });
}

/**
 * @description 游戏是否绑定微信APPID
 */
export async function getWechatIDStatus(params: any) {
  return request.get("/appid/weixin", {
    params: params,
  });
}

/**
 * @description 获取防沉迷公告
 */
export async function getAntiNotice(params: any) {
  return request.get("/Nameauth/info", {
    params: params,
  });
}

/**
 * @description 获取FAQ
 */
export async function getFaqList(params: any) {
  return request.get("/faq/list", {
    params: params,
  });
}

/**
 * @description 获取七鱼配置
 */
export async function getQiyuConfig(params: any) {
  return request.get("/QiyuConf/config", {
    params: params,
  });
}

/**
 * @description 获取用户基本信息
 */
export async function getUserBasicInfo() {
  return request.get("/CUser/info");
}

/**
 * @description 获取入口开关配置
 */
interface IEntryParams {
  channel_id: string;
  app_version: string;
}

interface IEntryRes {
  is_open: string;
  is_community: string;
  is_bind_kefu: string;
  kefu_name: string;
  kefu_url: string;
  native_qrcode_url: string;
  charge: string;
  guide_txt: string;
  button_txt: string;
  tips: string;
  community: {
    appId: string;
    path: string;
  };
  is_exchange: string;
  is_member: string;
}
export async function getEntryConfig(params: IEntryParams) {
  return request.get<IEntryRes>("/vip/v3/entry", {
    params,
  });
}

// 验证实名
interface IValidateRealnamePrarams {
  idcard: string;
  realname: string;
}
export async function validAateRealname(params: IValidateRealnamePrarams) {
  return request.get("/User/v23/h5DeleteQuery", {
    params,
  });
}

// 注销账号
export async function deleteAccount(params: IValidateRealnamePrarams) {
  return request.get("/User/v23/h5Delete", {
    params,
  });
}

interface IUnreadMessage extends IResponse {
  data: {
    feedback: number;
  };
}

// 获取未读消息
export async function getUnreadMessageCount(): Promise<IUnreadMessage> {
  return request.get("/user-center/v1/message/unread");
}

// 获取未读消息 - 微信
export async function getUnreadMessageCountWX(): Promise<IUnreadMessage> {
  return request.get("/user-center/wx-feedback/v1/message/unread");
}